import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Renee from "./pages/Renee";
import Contact from "./pages/Contact";
// import CookieConsent from "./components/CookieConsent";
import CaseStudy from "./pages/CaseStudy";
import ScrollToTop from "./components/ScrollToTop";
import Imprint from "./pages/Imprint";
import Privacy from "./pages/Privacy";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div
        className="min-h-screen bg-black text-white"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        {/* <CookieConsent /> */}
        <Navigation />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/:slug" element={<CaseStudy />} />
            <Route path="/renee" element={<Renee />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}